import React from "react";
import "../styles/StripesLeftBox.css";
import Timer from "./timer";

interface LeftBoxProps {
  setisStartGame: (value: boolean) => void;
  stateRestart?: boolean;
  isRunningTime: boolean;
  isStartGame: boolean;
  gameCompleted: boolean;
  onResetGame: () => void;
}

const LeftBox: React.FC<LeftBoxProps> = ({
  setisStartGame,
  stateRestart,
  isRunningTime,
  isStartGame,
  gameCompleted,
  onResetGame
}) => {
  const handleResetClick = () => {
    // Вызываем функцию сброса из App.tsx
    onResetGame();

  };
  return (
    <div className="strips-LeftBox">
      <a className="strips-logo" href="https://kotobot.app/index.html">
        <img className="strips-logo" src="/img/kotobot.svg" alt="Kotobot logo" />
      </a>
      <img className="strips-perslogo" src="/img/stripes/dragonfly.svg" alt="Dragonfly character" />
      <div className="strips-subtitle">Стрекоза Лиза</div>
      {!isStartGame && (
        <div className="strips-buttonLeftBox">
          <img
            src="/img/stripes/start.svg"
            className="strips-icon"
            title="Старт"
            alt=""
            onClick={() => {
              setisStartGame(true);
            }}
          />
        </div>
      )}
      {isStartGame && (
        <p className="strips-subtitle">
          {gameCompleted ? "Время: " : "Таймер: "}
          <Timer isRunningTime={isRunningTime} />
        </p>
      )}
      {gameCompleted && (
        <button
          className="strips-buttonLeftBox"
          onClick={handleResetClick}
          disabled={!isStartGame && !gameCompleted}
        >
          Играть ещё
        </button>
      )}
    </div>
  );
};

export default LeftBox;
